var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenMeetingRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25846_51755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 16.326V3.03434C22 1.76934 20.9733 0.742676 19.7083 0.742676H2.29167C1.02667 0.742676 0 1.76934 0 3.03434V16.326H10.5417V19.076H6.41667V19.9927H15.5833V19.076H11.4583V16.326H22ZM2.02583 15.4093L9.625 7.81018L13.2825 11.4677L21.0833 4.09768V15.4093H2.02583ZM2.29167 1.65934H19.7083C20.405 1.65934 20.9825 2.18184 21.0742 2.85101L13.3008 10.1843L9.625 6.50851L0.916667 15.2168V3.03434C0.916667 2.27351 1.53083 1.65934 2.29167 1.65934ZM3.66667 5.32601C3.66667 4.82184 4.07917 4.40934 4.58333 4.40934C5.0875 4.40934 5.5 4.82184 5.5 5.32601C5.5 5.83018 5.0875 6.24268 4.58333 6.24268C4.07917 6.24268 3.66667 5.83018 3.66667 5.32601Z",
    fill: "#178477",
    stroke: "#178477",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25846_51755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMeetingRoom);
export default __webpack_public_path__ + "static/media/green-meeting-room.3031e28589b51998146987369c1886af.svg";
export { ForwardRef as ReactComponent };